import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(32.000000, 29.000000)">
        <path
          d="M16.2614 44H0.792614V0.363635H16.3892C20.7784 0.363635 24.5568 1.23722 27.7244 2.98438C30.892 4.71733 33.3281 7.21023 35.0327 10.4631C36.7514 13.7159 37.6108 17.608 37.6108 22.1392C37.6108 26.6847 36.7514 30.5909 35.0327 33.858C33.3281 37.125 30.8778 39.6321 27.6818 41.3793C24.5 43.1264 20.6932 44 16.2614 44ZM10.0185 36.0952H15.8778C18.6051 36.0952 20.8991 35.6122 22.7599 34.6463C24.6349 33.6662 26.0412 32.1534 26.9787 30.108C27.9304 28.0483 28.4062 25.392 28.4062 22.1392C28.4062 18.9148 27.9304 16.2798 26.9787 14.2344C26.0412 12.1889 24.642 10.6832 22.7812 9.71733C20.9205 8.75142 18.6264 8.26847 15.8991 8.26847H10.0185V36.0952Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
